import { IANAZone, Settings, type Zone } from "luxon";
import { PackedZone } from "./packed-zone";
import { isShippedZone } from "./timezone-data";

const originalCreate = IANAZone.create.bind(IANAZone);
const originalResetCache = IANAZone.resetCache.bind(IANAZone);
const cache = new Map<string, PackedZone>();
const ianaZoneFactory = IANAZone as unknown as { create: (name: string) => Zone };
let installed = false;

// Luxon's default zone is SystemZone, which reads offsets from the host rather than from any
// IANAZone, so the override below cannot reach it. Naming the zone routes it back through create.
const adoptShippedHostZone = () => {
	const hostZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
	if (isShippedZone(hostZone)) {
		Settings.defaultZone = hostZone;
	}
};

export const installTzdataZones = () => {
	if (!installed) {
		ianaZoneFactory.create = (name: string) => {
			if (!isShippedZone(name)) {
				return originalCreate(name);
			}
			let zone = cache.get(name);
			if (!zone) {
				zone = new PackedZone(name);
				cache.set(name, zone);
			}
			return zone;
		};
		IANAZone.resetCache = () => {
			cache.clear();
			originalResetCache();
		};
		installed = true;
	}

	adoptShippedHostZone();
};
